import { render, staticRenderFns } from "./TratamentosConcluidos.vue?vue&type=template&id=698b79e2"
import script from "./TratamentosConcluidos.vue?vue&type=script&lang=js"
export * from "./TratamentosConcluidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports